import { toast } from 'react-toastify';

function isDevMode() {
    return !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
};

function logResponse(isDebugMode = false, message) {
    if(isDebugMode) toast.info(message);
}

export {
    isDevMode,
    logResponse,
}